const defaultState = {
    ajaxLoading: false,
    ajaxLoaded: false,
    network_models: [],
    page: 1,
    limit: 30,
    showEditModal: false,
    showRemoveModal: false,
    showDevicesTable: false,
    activeRow: {},
};

const network_models = (state = defaultState, action) => {
    switch (action.type) {
        case 'NETWORK_MODELS_SET_PAGE':
            return Object.assign({}, state, { page: action.payload });
        case 'NETWORK_MODELS_SET_LIMIT':
            return Object.assign({}, state, { limit: action.payload });
        case 'NETWORK_MODELS_SHOW_EDIT_MODAL':
            return Object.assign({}, state, { showEditModal: action.payload });
        case 'NETWORK_MODELS_SHOW_REMOVE_MODAL':
            return Object.assign({}, state, { showRemoveModal: action.payload });
        case 'NETWORK_MODELS_SHOW_DEVICES_TABLE':
            return Object.assign({}, state, { showDevicesTable: action.payload });
        case 'NETWORK_MODELS_TOGGLE_DEVICES_TABLE':
            return Object.assign({}, state, { showDevicesTable: !state.showDevicesTable });
        case 'NETWORK_MODELS_SET_ACTIVE_ROW':
            return Object.assign({}, state, { activeRow: action.payload });
        case 'NETWORK_MODELS_SET_ROW_VALUE':
            const activeRow = Object.assign({}, state.activeRow, action.payload);
            return Object.assign({}, state, { activeRow });
        case 'NETWORK_MODELS_FETCHING':
        case 'NETWORK_MODELS_SAVING':
        case 'NETWORK_MODELS_REMOVING':
            return Object.assign({}, state, { ajaxLoading: true });
        case 'NETWORK_MODELS_FETCHED':
            return Object.assign({}, state, { ajaxLoading: false, ajaxLoaded: true, network_models: action.payload });
        case 'NETWORK_MODELS_SAVED':
            return Object.assign({}, state, { ajaxLoading: false, showEditModal: false });
        case 'NETWORK_MODELS_REMOVED':
            return Object.assign({}, state, { ajaxLoading: false, showRemoveModal: false });
        default:
            return state;
    }
};

export default network_models;
